import React from "react";

function SvgFeedIconNew(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "20"}
      height={props.height || "20"}
      fill="currentColor"
      className="bi bi-briefcase-fill"
      viewBox="0 0 16 16"
    >
      <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5z" />
      <path d="M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85v5.65z" />
    </svg>
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   //@ts-ignore
    //   xmlnsXlink="http://www.w3.org/1999/xlink"
    //   width={props.width}
    //   height={props.height}
    //   viewBox="0 0 50 50"
    //   color="currentColor"
    // >
    //   <defs>
    //     <clipPath id="clip-Action_center_1">
    //       <rect width="50" height="50" />
    //     </clipPath>
    //   </defs>
    //   <g
    //     id="Action_center_1"
    //     data-name="Action center – 1"
    //     clip-path="url(#clip-Action_center_1)"
    //   >
    //     <g id="private-message" transform="translate(0 0)">
    //       <g
    //         id="Group_20002"
    //         data-name="Group 20002"
    //         transform="translate(0 2.169)"
    //       >
    //         <g id="Group_20001" data-name="Group 20001">
    //           <path
    //             id="Path_29226"
    //             data-name="Path 29226"
    //             d="M25.915,41.477a1.465,1.465,0,0,1-1.83,0L0,22.209V59.161a1.465,1.465,0,0,0,1.465,1.465H9.414v7.949a1.465,1.465,0,0,0,2.5,1.036L20.9,60.626H48.535A1.465,1.465,0,0,0,50,59.161V22.209Z"
    //             transform="translate(0 -22.209)"
    //             fill="currentColor"
    //           />
    //         </g>
    //       </g>
    //       <g
    //         id="Group_20004"
    //         data-name="Group 20004"
    //         transform="translate(1.979)"
    //       >
    //         <g id="Group_20003" data-name="Group 20003">
    //           <path
    //             id="Path_29227"
    //             data-name="Path 29227"
    //             d="M20.262,0,43.283,18.417,66.3,0Z"
    //             transform="translate(-20.262)"
    //             fill="currentColor"
    //           />
    //         </g>
    //       </g>
    //     </g>
    //   </g>
    // </svg>
  );
}
export default React.memo(SvgFeedIconNew);
